import { render, staticRenderFns } from "./modalDetailOutstandingMember.vue?vue&type=template&id=2c051f2a&scoped=true"
import script from "./modalDetailOutstandingMember.vue?vue&type=script&lang=js"
export * from "./modalDetailOutstandingMember.vue?vue&type=script&lang=js"
import style0 from "./modalDetailOutstandingMember.vue?vue&type=style&index=0&id=2c051f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c051f2a",
  null
  
)

export default component.exports